(function(){
var d=document,W=window,q=function(s,c){return (c||d).querySelector(s)},qa=function(s,c){return [].slice.call((c||d).querySelectorAll(s))};

/* ---------- product gallery ---------- */
var gal=q('[data-gal]');
if(gal){
var tabs=qa('[data-gal-tab]',gal),panes=qa('[data-gal-pane]',gal);
function show(id){
tabs.forEach(function(t){t.setAttribute('aria-selected',String(t.dataset.galTab===id))});
panes.forEach(function(p){
var on=p.dataset.galPane===id;p.classList.toggle('is-on',on);p.setAttribute('aria-hidden',String(!on));
if(on&&p.dataset.embed&&!q('iframe',p)){var f=d.createElement('iframe');f.src=p.dataset.embed;f.title='360° view of this diamond';f.loading='lazy';f.allow='fullscreen';p.innerHTML='';p.appendChild(f)}
});
}
tabs.forEach(function(t){t.addEventListener('click',function(){show(t.dataset.galTab)})});
}

/* ---------- gallery: feature chips on the photo, and which pane is showing ---------- */
(function(){var g=q('[data-gal]');if(!g)return;var st=q('.cc-gal__stage',g);
function mark(id){if(st)st.dataset.active=id}
qa('[data-gal-tab]',g).forEach(function(t){t.addEventListener('click',function(){mark(t.dataset.galTab)})});
qa('[data-gal-jump]',g).forEach(function(b){b.addEventListener('click',function(){var t=q('[data-gal-tab="'+b.dataset.galJump+'"]',g);if(t){t.click();t.scrollIntoView({block:'nearest',inline:'nearest'})}})});
var on=q('.cc-gal__thumbs [aria-selected="true"]',g);mark(on?on.dataset.galTab:'img0');})();

/* ---------- mobile sticky add-to-cart ---------- */
var atc=q('[data-atc]'),bar=q('[data-mbar]');
if(atc&&bar&&'IntersectionObserver' in W){
new IntersectionObserver(function(e){bar.classList.toggle('is-on',!e[0].isIntersecting&&e[0].boundingClientRect.top<0)}).observe(atc);
var mb=q('[data-mbar-btn]',bar);mb&&mb.addEventListener('click',function(){var b=q('.single_add_to_cart_button',atc);if(b)b.click();else W.scrollTo({top:atc.getBoundingClientRect().top+scrollY-120,behavior:'smooth'})});
}

/* ---------- stone enquiry pop-up ---------- */
var enq=q('[data-enq]');
if(enq){
var ef=q('[data-enq-form]',enq),emsg=q('[data-enq-msg]',enq),edone=q('[data-enq-done]',enq),lastFocus=null;
var modal=typeof enq.showModal==='function';
function eOpen(e){if(e)e.preventDefault();lastFocus=d.activeElement;if(modal)enq.showModal();else enq.setAttribute('open','');d.documentElement.style.overflow='hidden';setTimeout(function(){var i=q('input[name=name]',ef);if(i&&!matchMedia('(pointer:coarse)').matches)i.focus()},60)}
function eClose(){if(modal&&enq.open)enq.close();else enq.removeAttribute('open');d.documentElement.style.overflow='';if(lastFocus)lastFocus.focus()}
qa('[data-enq-open]').forEach(function(a){a.addEventListener('click',eOpen)});
qa('[data-enq-close]',enq).forEach(function(b){b.addEventListener('click',eClose)});
enq.addEventListener('click',function(e){if(e.target===enq)eClose()});
enq.addEventListener('close',function(){d.documentElement.style.overflow=''});
ef.addEventListener('submit',function(e){
e.preventDefault();
if(!ef.name.value.trim()||!/^\S+@\S+\.\S+$/.test(ef.email.value)){emsg.textContent='Please add your name and a valid email.';emsg.className='cc-enq__msg is-err';(ef.name.value.trim()?ef.email:ef.name).focus();return}
var b=q('.cc-enq__go',ef);b.disabled=true;b.textContent='Sending…';emsg.textContent='';emsg.className='cc-enq__msg';
window.ccContact(ef,ef.dataset.subject).then(function(x){
if(!x.ok)throw new Error('Could not send. Please email us.');
ef.hidden=true;edone.hidden=false;q('button',edone).focus();
}).catch(function(err){b.disabled=false;b.innerHTML='Send enquiry <span aria-hidden="true">→</span>';emsg.textContent=err.message||'Could not send. Please email us.';emsg.className='cc-enq__msg is-err'});
});
}

/* ---------- on-hand preview (gallery tab) ---------- */
(function(){
var hp=q('[data-hand]');if(!hp)return;
var FINGER=16.5; /* size 6 ring finger, mm */
var A=JSON.parse(hp.dataset.anchors),shape=hp.dataset.shape,ct0=+hp.dataset.ct||1;
var stage=q('[data-hand-stage]',hp),stone=q('[data-hand-stone]',hp),tint=q('[data-hand-tint]',hp),prongBox=q('[data-hand-prongs]',hp);
var range=q('[data-hand-ct]',hp),read=q('[data-hand-read]',hp),note=q('[data-hand-note]',hp),reset=q('[data-hand-reset]',hp);
var imgs=qa('[data-hand-img]',hp),tones=qa('[data-hand-tone]',hp),tone='medium',ready=false;
/* length/width ratio and the round-equivalent diameter used when a stone has no measurements */
var RATIO={round:1,oval:1.4,cushion:1.02,emerald:1.4,pear:1.55,princess:1,radiant:1.25,asscher:1,marquise:2,heart:1};
var mm=(hp.dataset.mm.match(/\d+(?:\.\d+)?/g)||[]).map(Number);
var L0,W0,measured=mm.length>=2&&mm[0]>0&&mm[1]>0;
if(measured){L0=Math.max(mm[0],mm[1]);W0=Math.min(mm[0],mm[1])}
else{var dr=6.5*Math.cbrt(ct0),r=RATIO[shape]||1;L0=dr*Math.sqrt(r)*.95;W0=dr/Math.sqrt(r)*.95}
if(shape==='round'){var dm=(L0+W0)/2;L0=W0=dm}
/* prongs as fractions of the stone box, centre origin */
var P={
round:[[.354,.354],[-.354,.354],[.354,-.354],[-.354,-.354]],
oval:[[.354,.354],[-.354,.354],[.354,-.354],[-.354,-.354]],
cushion:[[.4,.4],[-.4,.4],[.4,-.4],[-.4,-.4]],
emerald:[[.43,.45],[-.43,.45],[.43,-.45],[-.43,-.45]],
radiant:[[.44,.45],[-.44,.45],[.44,-.45],[-.44,-.45]],
asscher:[[.43,.43],[-.43,.43],[.43,-.43],[-.43,-.43]],
princess:[[.47,.47],[-.47,.47],[.47,-.47],[-.47,-.47]],
pear:[[0,-.49],[.38,.3],[-.38,.3]],
marquise:[[0,-.49],[0,.49],[.4,0],[-.4,0]],
heart:[[0,.48],[.42,-.3],[-.42,-.3]]
};
(P[shape]||P.round).forEach(function(p){var i=d.createElement('i');i.style.left=(50+p[0]*100)+'%';i.style.top=(50+p[1]*100)+'%';prongBox.appendChild(i)});
/* stone colour: repaint the stone by brightness rank with the real stone's palette (from its own photo, or the
   median of real photos of the same hue and intensity). The tint is only a last resort. */
var HUE={pink:'#F49AC1',blue:'#6FA8E6',yellow:'#F6CF3F',green:'#7CC57A',orange:'#F39A4C',red:'#D63F55',purple:'#A884D8',violet:'#A884D8',brown:'#A97A52',champagne:'#D9B77E',cognac:'#B06A2E',grey:'#9AA3AB',gray:'#9AA3AB'};
var INT={'faint':.2,'very light':.28,'light':.36,'fancy light':.42,'fancy':.55,'fancy intense':.72,'fancy deep':.78,'fancy dark':.78,'fancy vivid':.86};
var hue=(hp.dataset.hue||'').toLowerCase().trim(),it=(hp.dataset.intensity||'').toLowerCase().trim();
function fallbackTint(){
var hc=null;Object.keys(HUE).forEach(function(k){if(!hc&&hue.indexOf(k)>-1)hc=HUE[k]});
if(hue.indexOf('black')>-1){tint.style.background='#1b1d20';tint.style.mixBlendMode='multiply';tint.style.opacity=.9}
else if(hc){tint.style.background=hc;tint.style.opacity=INT[it]||.55}
else tint.remove();
}
function parsePal(h){var p=[];if(!h||h.length%6)return null;for(var k=0;k<h.length;k+=6)p.push([parseInt(h.substr(k,2),16),parseInt(h.substr(k+2,2),16),parseInt(h.substr(k+4,2),16)]);return p.length>1?p:null}
var simg=q('img',stone),thumbStone=q('.cc-thumb--hand .cc-thumb__stone');
function paint(pal){
var go=function(){
try{
var w=simg.naturalWidth,h=simg.naturalHeight;if(!w)return false;
var cv=d.createElement('canvas');cv.width=w;cv.height=h;var cx=cv.getContext('2d');cx.drawImage(simg,0,0);
var id=cx.getImageData(0,0,w,h),px=id.data,n=w*h,L=new Float32Array(n),solid=[];
for(var i=0;i<n;i++){var o=i*4;L[i]=px[o]*.2126+px[o+1]*.7152+px[o+2]*.0722;if(px[o+3]>127)solid.push(L[i])}
var sv=Float32Array.from(solid).sort(),m=sv.length,B=pal.length-1;if(m<16)return false;
var lb=function(v){var a=0,b=m;while(a<b){var c=(a+b)>>1;if(sv[c]<v)a=c+1;else b=c}return a},
    ub=function(v){var a=0,b=m;while(a<b){var c=(a+b)>>1;if(sv[c]<=v)a=c+1;else b=c}return a};
for(var j=0;j<n;j++){var o2=j*4;if(px[o2+3]<6)continue;
var r=((lb(L[j])+ub(L[j]))/2)/m,pos=Math.min(1,Math.max(0,r))*B,a0=Math.floor(pos),a1=Math.min(B,a0+1),t=pos-a0;
px[o2]=pal[a0][0]*(1-t)+pal[a1][0]*t;px[o2+1]=pal[a0][1]*(1-t)+pal[a1][1]*t;px[o2+2]=pal[a0][2]*(1-t)+pal[a1][2]*t}
cx.putImageData(id,0,0);var url=cv.toDataURL('image/png');
simg.src=url;if(thumbStone)thumbStone.src=url;tint.remove();return true;
}catch(e){return false}
};
if(simg.complete&&simg.naturalWidth){if(!go())fallbackTint()}
else simg.addEventListener('load',function once(){simg.removeEventListener('load',once);if(!go())fallbackTint()});
}
var own=parsePal(hp.dataset.pal);
if(own)paint(own);
else if(hue){
fetch(hp.dataset.palettes,{credentials:'same-origin'}).then(function(r){return r.json()}).then(function(g){
var p=parsePal(g[hue+'|'+it]||g[hue]);if(p)paint(p);else fallbackTint();
}).catch(fallbackTint);
}
else tint.remove();
/* carat stops: standard weights plus this stone */
var stops=[.5,.75,1,1.25,1.5,1.75,2,2.5,3,3.5,4,5];
if(ct0>5)[6,7,8,10,12,15].forEach(function(v){if(v<ct0)stops.push(v)});
if(stops.indexOf(ct0)<0)stops.push(ct0);
stops.sort(function(a,b){return a-b});
var i0=stops.indexOf(ct0);
range.max=stops.length-1;range.value=i0;
function fmt(v){return v.toFixed(v<10?2:1)}
function dims(ct){var k=Math.cbrt(ct/ct0);return [L0*k,W0*k]}
function place(){
var a=A[tone],ct=stops[+range.value],dm=dims(ct),pxmm=a.f/FINGER;
stone.style.left=a.x+'%';stone.style.top=a.y+'%';
stone.style.width=(dm[1]*pxmm)+'%';stone.style.height=(dm[0]*pxmm)+'%';
stone.style.setProperty('--prong',(.95*pxmm)+'cqw');
var size=shape==='round'?'Ø '+dm[0].toFixed(1)+' mm':dm[0].toFixed(1)+' × '+dm[1].toFixed(1)+' mm';
read.textContent=fmt(ct)+' ct · '+size;
var own=+range.value===i0;
note.textContent=own?'This stone, actual size on a size 6 finger.':'A '+fmt(ct)+' ct '+(hp.dataset.shapeName||shape)+' with the same proportions, for comparison.';
reset.hidden=own;
stage.setAttribute('aria-label',(own?'This ':'A ')+fmt(ct)+' carat stone, '+size+', shown at actual size on a size 6 finger, '+tone+' skin tone');
range.setAttribute('aria-valuetext',fmt(ct)+' carats, '+size+(own?', this stone':''));
}
function setTone(t){
tone=t;
tones.forEach(function(b){b.setAttribute('aria-checked',String(b.dataset.handTone===t))});
imgs.forEach(function(im){im.classList.toggle('is-on',im.dataset.handImg===t)});
place();
}
function init(){
if(ready)return;ready=true;
imgs.forEach(function(im){if(im.dataset.src){im.src=im.dataset.src;im.removeAttribute('data-src')}});
}
tones.forEach(function(b){b.addEventListener('click',function(){init();setTone(b.dataset.handTone)})});
range.addEventListener('input',place);
reset.addEventListener('click',function(){range.value=i0;place();range.focus()});
qa('[data-gal-tab="hand"]').forEach(function(t){t.addEventListener('click',init)});
place();
})();

/* ---------- PDP upgrade comparison ---------- */
(function(){
var upg=q('[data-upgrade]');if(!upg)return;
var C=W.CC||{},ROOT=C.root||'/';
var BANDS=[[0,0.5,'0.01–0.49 ct'],[0.5,0.75,'0.50–0.74 ct'],[0.75,1,'0.75–0.99 ct'],[1,1.5,'1.00–1.49 ct'],[1.5,2,'1.50–1.99 ct'],[2,2.5,'2.00–2.49 ct'],[2.5,3,'2.50–2.99 ct'],[3,4,'3.00–3.99 ct'],[4,5,'4.00–4.99 ct'],[5,9999,'5.00 ct +']];
function bandsFor(lo,hi){return BANDS.filter(function(b){return b[1]>lo&&b[0]<=hi}).map(function(b){return b[2]})}
function fParams(p,key,vals){vals.forEach(function(v){p.append('filter.p.m.ccs.'+key,v)})}
function searchURL(p){p.set('q',C.catalogQ||'diamond');p.set('type','product');p.set('section_id','cc-data');return ROOT+'search?'+p.toString()}
function money(v){return '$'+Math.round(v).toLocaleString()}
function esc(s){return (s==null?'':String(s)).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]})}
function fetchJSON(url){return fetch(url,{credentials:'same-origin'}).then(function(r){return r.text()}).then(function(h){var m=new DOMParser().parseFromString(h,'text/html').querySelector('script[data-cc-data]');return m?JSON.parse(m.textContent):null}).catch(function(){return null})}

var shape=upg.dataset.upgShape,color=(upg.dataset.upgColor||'').toUpperCase(),clarity=(upg.dataset.upgClarity||'').toUpperCase(),
    cut=(upg.dataset.upgCut||'').toUpperCase(),ct=+upg.dataset.upgCarat,price=+upg.dataset.upgPrice,handle=upg.dataset.upgHandle,isColored=upg.dataset.upgColored==='1';
var rowsEl=q('[data-upg-rows]',upg);
var COLOR_ORDER=['D','E','F','G','H','I','J','K','L','M'];
var CLARITY_ORDER=['FL','IF','VVS1','VVS2','VS1','VS2','SI1','SI2','I1','I2','I3'];

var CUT_ORDER=['IDEAL','EXCELLENT','VERY GOOD','GOOD','FAIR'],cutRank=CUT_ORDER.indexOf(cut);
function cutOK(it){if(cutRank<0)return true;var r=CUT_ORDER.indexOf((it.cu||'').toUpperCase());return r>=0&&r<=cutRank}
function sameSize(it){return it.c>=ct-0.005&&it.c<=ct*1.07}
function sameColor(it){return !isColored||(it.co||'').toUpperCase()===color}
function bestCandidate(params,extraFilter){
  return fetchJSON(searchURL(params)).then(function(j){
    if(!j||!j.items)return null;
    var cands=j.items.filter(function(it){return it.h&&it.h!==handle&&it.p>price&&cutOK(it)&&(!extraFilter||extraFilter(it))});
    cands.sort(function(a,b){return a.p-b.p});
    return cands[0]||null;
  });
}

var slots=[null,null,null];
var tasks=[];

if(!isColored&&color){
  var cIdx=COLOR_ORDER.indexOf(color);
  if(cIdx>0){
    var p1=new URLSearchParams();
    fParams(p1,'shape',[shape]);fParams(p1,'color',COLOR_ORDER.slice(0,cIdx));fParams(p1,'clarity',[clarity]);fParams(p1,'carat_band',bandsFor(ct*0.93,ct*1.07));
    tasks.push(bestCandidate(p1,sameSize).then(function(cand){if(cand)slots[0]={tag:'Higher color',hl:'co',cand:cand}}));
  }
}
if(clarity){
  var clIdx=CLARITY_ORDER.indexOf(clarity);
  if(clIdx>0){
    var p2=new URLSearchParams();
    fParams(p2,'shape',[shape]);if(!isColored)fParams(p2,'color',[color]);fParams(p2,'clarity',CLARITY_ORDER.slice(0,clIdx));fParams(p2,'carat_band',bandsFor(ct*0.93,ct*1.07));
    tasks.push(bestCandidate(p2,function(it){return sameSize(it)&&sameColor(it)}).then(function(cand){if(cand)slots[1]={tag:'Better clarity',hl:'cl',cand:cand}}));
  }
}
{
  var p3=new URLSearchParams();
  fParams(p3,'shape',[shape]);if(!isColored)fParams(p3,'color',[color]);fParams(p3,'clarity',[clarity]);fParams(p3,'carat_band',bandsFor(ct*1.03,ct*1.3));
  tasks.push(bestCandidate(p3,function(it){return it.c>ct&&sameColor(it)}).then(function(cand){if(cand)slots[2]={tag:'Larger carat',hl:'c',cand:cand}}));
}

Promise.all(tasks).then(function(){
  var rows=slots.filter(Boolean);
  if(!rows.length)return;
  rows.forEach(function(r){
    var c=r.cand,from,to,rest=[];
    if(r.hl==='c'){from=ct.toFixed(2);to=c.c.toFixed(2)+' ct'}else rest.push(c.c.toFixed(2)+' ct');
    if(r.hl==='co'){from=color;to=c.co}else if(c.co)rest.push(c.co);
    if(r.hl==='cl'){from=clarity;to=c.cl}else if(c.cl)rest.push(c.cl);
    if(c.cu)rest.push(c.cu+' cut');
    var a=d.createElement('a');
    a.className='cc-upg__row';
    a.href=ROOT+'products/'+c.h;
    a.innerHTML=
      '<span class="cc-upg__kind">'+r.tag+'</span>'+
      '<span class="cc-upg__price">+'+money(c.p-price)+'</span>'+
      '<span class="cc-upg__change"><span class="cc-upg__from">'+esc(from)+'</span><span class="cc-upg__to" aria-label="to">'+esc(to)+'</span></span>'+
      '<span class="cc-upg__go">View stone</span>'+
      '<span class="cc-upg__rest">'+esc(rest.join(' · '))+'</span>';
    rowsEl.appendChild(a);
  });
  upg.hidden=false;
  if('IntersectionObserver' in W&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
    upg.classList.add('is-anim');
    var ioAlive=false;
    var io=new IntersectionObserver(function(es){ioAlive=true;if(es[0].isIntersecting){upg.classList.add('is-in');io.disconnect()}},{threshold:.3});
    io.observe(upg);
    /* an observer that never reports must not leave the block invisible */
    setTimeout(function(){if(!ioAlive){upg.classList.add('is-in');io.disconnect()}},4000);
  }else upg.classList.add('is-in');
});
})();

/* ---------- listing filters ---------- */
var form=q('[data-plp-form]');
if(!form)return;
var results=q('[data-plp-results]'),timer=0,ctrl=null;

function fmt(v,kind){return kind==='price'?'$'+Math.round(v).toLocaleString():(+v).toFixed(2)}
function initRanges(scope){
qa('.cc-range',scope).forEach(function(r){
var a=qa('input[type=range]',r),n=qa('.cc-range__nums input',r.parentNode),fill=q('.cc-range__fill',r),out=q('output',r.parentNode),kind=r.dataset.kind;
var min=+a[0].min,max=+a[0].max;
function paint(){
var lo=Math.min(+a[0].value,+a[1].value),hi=Math.max(+a[0].value,+a[1].value);
fill.style.left=((lo-min)/(max-min)*100)+'%';fill.style.right=(100-(hi-min)/(max-min)*100)+'%';
if(out)out.textContent=fmt(lo,kind)+' – '+fmt(hi,kind);
return [lo,hi];
}
/* carat: Shopify filters ccs.carat_band by exact value, so the slider ticks the bands it covers and snaps to their edges */
function snap(){if(kind!=='carat')return;var v=paint(),bx=qa('[data-band-lo]',r.parentNode),full=v[0]<=min&&v[1]>=max,lo=Infinity,hi=-Infinity;
bx.forEach(function(c){var bl=+c.dataset.bandLo,bh=+c.dataset.bandHi;c.checked=!full&&bl<=v[1]&&bh>v[0];if(c.checked){lo=Math.min(lo,bl);hi=Math.max(hi,bh-0.01)}});
if(full||lo===Infinity)return;lo=Math.max(min,lo);hi=Math.min(max,hi);a[0].value=lo;a[1].value=hi;v=paint();n[0].value=v[0].toFixed(2);n[1].value=v[1].toFixed(2)}
a.forEach(function(x){x.addEventListener('input',function(){var v=paint();n[0].value=kind==='price'?Math.round(v[0]):v[0].toFixed(2);n[1].value=kind==='price'?Math.round(v[1]):v[1].toFixed(2)});x.addEventListener('change',function(){snap();queue()})});
n.forEach(function(x,i){x.addEventListener('change',function(){var v=Math.max(min,Math.min(max,+x.value||0));a[i].value=v;paint();snap();queue()})});
paint();
});
}
function buildURL(){
var p=new URLSearchParams();
new FormData(form).forEach(function(v,k){if(typeof v==='string'&&v!=='')p.append(k,v)});
qa('.cc-range',form).forEach(function(r){
if(r.dataset.kind==='carat')return;
var a=qa('input[type=range]',r),n=qa('.cc-range__nums input',r.parentNode),lo=Math.min(+a[0].value,+a[1].value),hi=Math.max(+a[0].value,+a[1].value);
p.delete(n[0].name);p.delete(n[1].name);
if(lo>+a[0].min)p.set(n[0].name,n[0].value);
if(hi<+a[0].max)p.set(n[1].name,n[1].value);
});
var s=q('select[name=sort_by]',form);if(s&&s.value===s.dataset.default)p.delete('sort_by');
var base=form.getAttribute('action');
var qs=p.toString().replace(/%2C/g,',');
return base+(qs?'?'+qs:'');
}
function countActive(){
var n=qa('input[type=checkbox][data-group]:checked',form).length;
qa('.cc-range',form).forEach(function(r){var a=qa('input[type=range]',r);if(Math.min(+a[0].value,+a[1].value)>+a[0].min||Math.max(+a[0].value,+a[1].value)<+a[0].max)n++});
qa('[data-fcount]').forEach(function(el){el.textContent=n;el.dataset.n=n});
}
function load(url,replaceForm){
if(ctrl)ctrl.abort();ctrl='AbortController' in W?new AbortController():null;
results.classList.add('is-loading');
fetch(url,{headers:{'X-CC-Ajax':'1'},signal:ctrl&&ctrl.signal,credentials:'same-origin'}).then(function(r){return r.text()}).then(function(html){
var doc=new DOMParser().parseFromString(html,'text/html');
['[data-plp-results]','[data-plp-count]','[data-plp-active]','[data-plp-show]'].forEach(function(s){var a=q(s),b=q(s,doc);if(a&&b)a.innerHTML=b.innerHTML});
if(replaceForm){var nf=q('[data-plp-form]',doc);if(nf){form.innerHTML=nf.innerHTML;initRanges(form)}}
countActive();
results.classList.remove('is-loading');
if(url!==location.pathname+location.search&&url!==location.href)history.pushState({cc:1},'',url);
}).catch(function(e){if(e.name!=='AbortError')location.href=url});
}
function queue(){countActive();clearTimeout(timer);timer=setTimeout(function(){load(buildURL(),false)},320)}

form.addEventListener('change',function(e){if(!e.target.matches('input[type=range],.cc-range__nums input'))queue()});
form.addEventListener('submit',function(e){e.preventDefault();load(buildURL(),false)});
d.addEventListener('click',function(e){
var a=e.target.closest('[data-plp-active] a,[data-plp-results] .cc-pages a');
if(a){e.preventDefault();load(a.href,true);var top=q('[data-plp-top]');if(top&&a.closest('.cc-pages'))W.scrollTo({top:top.getBoundingClientRect().top+scrollY-120,behavior:'smooth'})}
});
W.addEventListener('popstate',function(){load(location.href,true)});

/* fancy shape families (delegated: survives form refresh) */
d.addEventListener('click',function(e){
var t=e.target.closest('[data-fam-tab]'),all=e.target.closest('[data-fam-all]');
if(!t&&!all)return;
var box=(t||all).closest('[data-fam]');if(!box)return;
var tiles=qa('.cc-fshape--fancy',box),btn=q('[data-fam-all]',box);
if(all){tiles.forEach(function(x){x.hidden=false});all.hidden=true;qa('[data-fam-tab]',box).forEach(function(b){b.setAttribute('aria-selected','false')});return}
var f=t.dataset.famTab;
qa('[data-fam-tab]',box).forEach(function(b){b.setAttribute('aria-selected',String(b===t))});
tiles.forEach(function(x){x.hidden=(' '+x.dataset.fam+' ').indexOf(' '+f+' ')<0});
if(btn)btn.hidden=f!=='all';
});
var more=q('[data-more]'),morePanel=q('.cc-fpanels--more');
more&&more.addEventListener('click',function(){var h=!morePanel.hidden;morePanel.hidden=h;more.setAttribute('aria-expanded',String(!h));more.textContent=h?'More filters +':'Fewer filters −'});

var drawer=q('[data-drawer]');
function openD(o){if(!drawer)return;drawer.classList.toggle('is-open',o);d.body.style.overflow=o?'hidden':''}
qa('[data-drawer-open]').forEach(function(b){b.addEventListener('click',function(){openD(true)})});
qa('[data-drawer-close]').forEach(function(b){b.addEventListener('click',function(){openD(false)})});
d.addEventListener('keydown',function(e){if(e.key==='Escape')openD(false)});

function loadMore(){
var old=q('[data-plp-results] .cc-loadmore');if(old)old.remove();
var pages=q('[data-plp-results] .cc-pages'),next=pages&&q('a.next',pages);
if(!next)return;
var wrap=d.createElement('div');wrap.className='cc-loadmore';var b=d.createElement('button');b.type='button';b.textContent='Show more stones';wrap.appendChild(b);pages.parentNode.insertBefore(wrap,pages);
b.addEventListener('click',function(){b.disabled=true;b.textContent='Loading…';
fetch(next.href,{headers:{'X-CC-Ajax':'1'},credentials:'same-origin'}).then(function(r){return r.text()}).then(function(h){
var doc=new DOMParser().parseFromString(h,'text/html'),grid=q('[data-plp-results] .cc-stones'),ng=q('[data-plp-results] .cc-stones',doc),np=q('[data-plp-results] .cc-pages',doc);
if(grid&&ng)[].slice.call(ng.children).forEach(function(c){grid.appendChild(c)});
if(np)pages.innerHTML=np.innerHTML;else pages.remove();
loadMore();
}).catch(function(){location.href=next.href})});
}
new MutationObserver(function(){if(!q('[data-plp-results] .cc-loadmore'))loadMore()}).observe(results,{childList:true});
initRanges(form);countActive();loadMore();
})();
